<template>
  <round :device="device">
    <div>
      <img :src="icon" style="height: 65px;"/>
    </div>
    <div slot="footer" class="footer">
      <div v-text="text"></div>
    </div>
  </round>
</template>
<script>
import Round from './Round'

export default {
  name: 'DeviceSwitch',
  props: {
    device: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    icon () {
      if (this.device.name.indexOf('射灯') === -1) {
        if (this.device.state.state) {
          return require('../assets/images/device/switch/device_switch_e.png')
        } else {
          return require('../assets/images/device/switch/device_switch.png')
        }
      } else {
        if (this.device.state.state) {
          return require('../assets/images/device/switch/device_spotlight_e.png')
        } else {
          return require('../assets/images/device/switch/device_spotlight.png')
        }
      }
    },
    text () {
      if (this.device.state.state) {
        return '已开启'
      } else {
        return '已关闭'
      }
    }
  },
  components: {
    Round
  },
  methods: {}
}
</script>
<style scoped lang="less">
.round {
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
  }
}
</style>
